module.exports = __webpack_public_path__ + "assets/img/56@3x.bca6fcfb.png";